module.exports = __webpack_public_path__ + "img/noteice.a1377356.svg";